import { render } from "./Tools.vue?vue&type=template&id=5c5d787c&ts=true&lang=pug"
import script from "./Tools.vue?vue&type=script&lang=ts"
export * from "./Tools.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__